<template>
    <div class="modal fade show add-note-modal" aria-labelledby="addNewCardTitle">
        <div class="modal-dialog modal-dialog-centered modal-md">
            <div class="modal-content">
                <div class="row">
                    <div class="col-12">
                        <div class="d-flex justify-content-between px-1 my-1 align-item-center">
                            <h1 class="mb-0">{{ title }}</h1>
                            <button @click="closeModal" type="button" class="btn-close" data-bs-dismiss="modal"
                                aria-label="Close"></button>
                        </div>
                    </div>
                </div>
                <hr class="mt-0">
                <div class="modal-body">
                    <div class="pb-2">
                        <div class="row">
                            <div v-if="parent" class="col-12 col-sm-12 col-md-12 col-lg-12 mb-1">
                                <label class="form-label" for="gender">Parent Group</label>
                                <input
                                    name="parent_group"
                                    type="text"
                                    class="form-control"
                                    v-model.trim="parent.name"
                                    disabled readonly
                                />
                            </div>
                            <div class="col-12 col-sm-12 col-md-12 col-lg-12 mb-1">
                                <label class="form-label" for="name">Name <span class="required">*</span></label>
                                <input
                                    name="name"
                                    type="text"
                                    class="form-control"
                                    v-model.trim="formData.name"
                                    placeholder="Enter Name"
                                />
                           </div>

                          <div v-if="!parent" class="col-12 col-sm-12 col-md-12 col-lg-12 mb-1">
                            <label class="form-label">Calculation Type</label>
                            <v-select
                                placeholder="Select Status"
                                v-model="formData.calculation_type"
                                :options="calculationTypeList"
                                label="name"
                                :reduce="name => name.value"
                            />
                          </div>

                          <div v-if="!parent && formData.calculation_type == 'target'" class="col-12 col-sm-12 col-md-12 col-lg-12 mb-1">
                            <label class="form-label">Is Count Total Performance Score</label>
                            <input type="checkbox" v-model="formData.is_count_total_performance_score" class="form-check-input">
                          </div>

                           <div class="col-12 col-sm-12 col-md-12 col-lg-12 mb-1">
                            <label class="form-label">Weight</label>
                            <input
                                name="code"
                                type="text"
                                class="form-control"
                                v-model.trim="formData.weight"
                                placeholder="Enter Weight"
                            />
                          </div>
                          <div class="col-12 col-sm-12 col-md-12 col-lg-12 mb-1">
                            <label class="form-label">Code</label>
                            <input
                                name="code"
                                type="text"
                                class="form-control"
                                v-model.trim="formData.code"
                                placeholder="Enter Code"
                            />
                          </div>

                          <div v-if="parent" class="col-12 col-sm-12 col-md-12 col-lg-12 mb-1">
                            <label class="form-label">Default Type</label>
                            <v-select
                                placeholder="Select Default Type"
                                v-model="formData.default_type"
                                :options="defaultTypeList"
                                label="name"
                                :reduce="name => name.value"
                            />
                          </div>

                            <div class="col-12 col-sm-12 col-md-12 col-lg-12 mb-1">
                                <label class="form-label">Description</label>
                                <textarea
                                    name="description"
                                    class="form-control"
                                    placeholder="Enter Description"
                                    :rows="2"
                                    v-model="formData.description"
                                ></textarea>
                            </div>

                            <div class="col-12 col-sm-12 col-md-12 col-lg-12 mb-1">
                              <label class="form-label">Status</label>
                              <v-select
                                  placeholder="Select Default Type"
                                  v-model="formData.status"
                                  :options="statusList"
                                  label="name"
                                  :reduce="name => name.value"
                              />
                            </div>
                            <div class="col-12 text-center">
                                <hr>
                                <SubmitCancelBtn
                                    class="text-center"
                                    @onSubmit="submit"
                                    @onCancel="closeModal"
                                    :loading="loading"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { inject, onMounted, ref } from "vue";
import { useStore } from "vuex";
import SubmitCancelBtn from '@/components/atom/SubmitCancelBtn.vue';
import { useRoute } from "vue-router";
import cloneDeep from "lodash/cloneDeep";
import handleHrPayroll from "@/services/modules/hrPayroll/hrPayroll";
import { computed } from "vue";

const props = defineProps({
    title: {
        type: String,
        default: ''
    },
    activityType: {
        type: String,
        required: true
    },
    parent: {
        type: Object,
        default: null
    },
    calculationTypeList: {
      type: Array,
      default: []
    },
    defaultTypeList: {
      type: Array,
      default: []
    },
    statusList: {
      type: Array,
      default: []
    },
    editData: {
        type: Object,
        default: null
    }
})

const emit = defineEmits(['onSubmit']);
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const { createPerformanceComponentSetup, updatePerformanceComponentSetup } = handleHrPayroll();

const store = useStore();
const route = useRoute();
const loading = ref(false);
const formData = ref({
    company_id: route.params.companyId,
    performance_component_setup_id: null,
    name: '',
    weight: '',
    code: '',
    type: '',
    default_type: '',
    calculation_type: '',
    group_level: 0,
    is_count_total_performance_score: false,
    description: '',
    status: 'active',
});

const headType = computed(() => {
    if(['group', 'childGroup'].includes(props.activityType)) {
        return 'group';
    }
    return 'endpoint';
})

const closeModal = () => {
    props.editData = {}
    store.state.isModalOpen = false;
}

const submit = async () => {
    const formattedData = formatFormData();

    const id = props.editData ? props.editData.id : null;
    const activityAction = id ? updatePerformanceComponentSetup : createPerformanceComponentSetup;

    loading.value = true

    await activityAction(formattedData, id).then((res) => {
        loading.value = false
        if (!res.status) return showError(res.message);
        showSuccess(res.message);
        closeModal();
        emit('onSubmit');
    }).catch(err => {
        console.log(err)
    }).finally(() => {
        loading.value = false
    })
}

const formatFormData = () => {
    const data = cloneDeep(formData.value);
    data.type = headType.value;
    return data;
}

const setEditData = () => {
    formData.value.name = props.editData.name;
    formData.value.weight = props.editData.weight;
    formData.value.code = props.editData.code;
    formData.value.calculation_type = props.editData.calculation_type;
    formData.value.default_type = props.editData.default_type;
    formData.value.description = props.editData.description;
    formData.value.status = props.editData.status;
    formData.value.is_count_total_performance_score = props.editData.is_count_total_performance_score === 1;
}

onMounted(() => {

    if(props.parent){
        formData.value.performance_component_setup_id = props.parent.id;
    }

    if(props.editData){
        setEditData();
    }
})

</script>

<style>
.discharge-rx .row {
    padding: 0 2% !important;
}
.discharge-rx {
    margin-top: 0 !important;
    margin-bottom: 2%;
    margin-left: 0 !important;
}

.med-title{
    padding: 0.486rem 1.5rem;
}
.modal-card{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
}
.add-note-modal {
    display: block; 
    background: #1c1d1c33
}
</style>